module.exports = __webpack_public_path__ + "img/star.c0c3cc03.svg";